import { translate } from "./translate";
import { transliterate } from "./transliterate";
import { restrictedWords } from "./translationConfig";
import { getOverride } from "./translationOverrides";

const cache = new Map<string, string>();

export const smartTranslate = async (text: string, lang: string) => {
  if (!text) return text;

  const hasNonLatin = /[^\u0000-\u007F]/.test(text);

  // If text has Korean/Kannada chars → still translate to English
  if (lang === "en" && !hasNonLatin) return text;

  const key = `${lang}_${text}`;
  if (cache.has(key)) return cache.get(key)!;

  const overrideValue = getOverride(text, lang);
  if (overrideValue) {
    cache.set(key, overrideValue);
    return overrideValue;
  }

  const restore: Record<string, string> = {};
  let processed = text;

  for (let i = 0; i < restrictedWords.length; i++) {
    const word = restrictedWords[i];
    if (processed.includes(word)) {
      const token = `__RW_${i}__`;
      const wordOverride = getOverride(word, lang);
      restore[token] = wordOverride ?? await transliterate(word, lang);
      processed = processed.replaceAll(word, token);
    }
  }

  let translated = await translate(processed, lang);

  for (const [token, lipi] of Object.entries(restore)) {
    translated = translated.replaceAll(token, lipi);
  }

  cache.set(key, translated);
  return translated;
};